import Ionicons from '@expo/vector-icons/Ionicons';
import { Box, Image, Text, makeUclComponent } from '@rbilabs/universal-components';

import ActionButton from 'components/action-button';
import { primitive } from 'styles/constants';

export const Title = Text.withConfig({
  fontSize: 'lg',
  color: primitive.$white,
  fontWeight: 'bold',
});

export const RetakeText = Text.withConfig({
  fontSize: 12,
  color: primitive.$white,
  fontWeight: 'bold',
  justifyContent: 'center',
});

export const CustomButton = makeUclComponent(ActionButton).withConfig({
  fullWidth: false,
  letterSpacing: '0.5px',
  padding: '$1',
  paddingX: '$3',
  backgroundColor: primitive.$black,
  _text: {
    fontSize: 12,
    color: primitive.$white,
  },
});

export const SubmitYourPhotoButton = makeUclComponent(ActionButton).withConfig({
  width: 300,
  margin: 'auto',
  bottom: 3,
});

export const RetakeButton = CustomButton.withConfig({
  borderColor: primitive.$white,
  borderWidth: '2px',
  height: 30,
});

export const TopBar = Box.withConfig({
  left: 0,
  right: 0,
  flexDirection: 'row',
  justifyContent: 'space-between',
  backgroundColor: primitive.$black,
  zIndex: 10,
  width: '100%',
  paddingX: 2,
});

export const PromptTextContainer = Box.withConfig({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  alignItems: 'center',
  backgroundColor: 'rgba(0,0,0,0.2)',
  paddingY: 4,
});

export const PromptText = Text.withConfig({
  color: primitive.$white,
  fontSize: 'xl',
  fontWeight: 'bold',
});

export const CameraIcons = makeUclComponent(Ionicons).withConfig({
  fontSize: 28,
  color: primitive.$white,
});

export const OverlayContainer = Box.withConfig({
  position: 'absolute',
  bottom: 0,
  left: 0,
  right: 0,
  alignItems: 'center',
  backgroundColor: primitive.$blackOpacity20,
  paddingY: 4,
  zIndex: 10,
  width: '100%',
  height: '100%',
});

export const CameraInstructionPopup = Box.withConfig({
  position: 'absolute',
  top: 2, // or adjust as needed
  alignSelf: 'center',
  bg: 'white',
  px: 6,
  py: 4,
  rounded: '2xl',
  shadow: 4,
  zIndex: 999,
  maxW: '90%',
});

export const CameraInstructionText = Text.withConfig({
  color: '#5A3625', // Close to your brown
  fontWeight: 'bold',
  fontSize: 'lg',
  textAlign: 'center',
});

export const ImageOverlayContainer = Box.withConfig({
  position: 'absolute',
  zIndex: 2,
  alignItems: 'center',
  pointerEvents: 'none',
  bottom: 0,
  left: 0,
  right: 0,
});

export const ImageOverlay = Image.withConfig({
  width: '100%',
  height: '100%',
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 10,
});
